module.exports = __webpack_public_path__ + "img/path-white.12e87f80.svg";